import modalYesNo from './modal-yes-no';
export default modalYesNo;